import { useState, Fragment, useContext, useEffect } from 'react';
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { FiMenu } from 'react-icons/fi'
import { IoMdClose } from 'react-icons/io'
import { Link } from 'react-router-dom';
import authContext from '../context/auth/authContext';
import ContextStates from '../context/ContextStates';
import Alertas from './admin/alertas';
import Switch from "react-switch";
import { FaTag, FaUserCircle, FaDollarSign } from 'react-icons/fa';


const navigation = [
    { name: 'Ventas', href: '/', current: false },
    /*{ name: 'Compras', href: '/compras', current: false },*/
    { name: 'Jornada de Caja', href: '/jornadas', current: false },
    { name: 'Administración', href: '/admin', current: false },
    { name: 'Clientes', href: '/admin/clientes', current: false },
    { name: 'Repartos', href: '/admin/repartos', current: false },
]

const precios = [
    { id: 1, precio: "Normal" },
    { id: 2, precio: "Precio 2" },
    { id: 3, precio: "Precio 3" }
]

export const NavBar = () => {
    const { usuarioAutenticado, cerrarSesion } = useContext(authContext);

    const { setFormView, setViewOpen, pendientes, precio, setPrecio, nombre, roles, tipoPrecio, setTipoPrecio } = useContext(ContextStates)
    const mail = localStorage.getItem('pvp_em');

    useEffect(() => {
        usuarioAutenticado()
    }, []);


    return (
        <Disclosure as="nav" className="shadow-xl bg-gradient-to-r from-slate-50 to-blue-50 border-b-2 border-blue-100">
            {({ open }) => (
                <>
                    <div className="container mx-auto px-2 sm:px-4 lg:px-6">
                        <div className="relative flex items-center justify-between h-20">
                            {/* Mobile menu button */}
                            <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-lg text-gray-600 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500 transition-all duration-200">
                                    <span className="sr-only">Abrir Menú</span>
                                    {open ? (
                                        <IoMdClose className="block h-6 w-6" aria-hidden="true" />
                                    ) : (
                                        <FiMenu className="block h-6 w-6" aria-hidden="true" />
                                    )}
                                </Disclosure.Button>
                            </div>

                            {/* Logo and navigation */}
                            <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                                <div className="flex-shrink-0 flex items-center ml-10 sm:ml-0">
                                    <Link to="/">
                                        <p className='text-xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent'>{nombre}</p>
                                    </Link>
                                </div>
                                <div className="hidden lg:block lg:ml-6">
                                    <div className="flex space-x-2">
                                        {navigation.map((item) => (
                                            <Link
                                                key={item.name}
                                                to={item.href}
                                                className={`px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${item.current ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-blue-500 hover:text-white'}`}
                                                aria-current={item.current ? 'page' : undefined}
                                            >
                                                {item.name}
                                            </Link>
                                        ))}
                                    </div>
                                </div>

                                {/* Ingreso button */}
                                <div className="hidden lg:block lg:ml-4">
                                    <button className='text-gray-700 px-3 py-2 text-sm font-medium hover:bg-blue-100 rounded-lg transition-all duration-200'
                                        onClick={() => {
                                            setFormView(209);
                                            setViewOpen(true);
                                        }}
                                    >
                                        Ingreso
                                    </button>
                                </div>
                            </div>

                            {/* Right side items */}
                            <div className="absolute inset-y-0 right-0 flex items-center gap-2 pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">

                                {/* Price Type Radio Buttons - Hidden on small screens */}
                                <div className='hidden md:flex items-center bg-white rounded-lg shadow-sm border border-gray-200 p-2 gap-1'>
                                    <FaTag className='text-gray-500 text-sm mr-1' />
                                    {typeof precios !== 'undefined' && precios.map((item, index) => (
                                        <label
                                            key={index}
                                            className={`flex items-center px-3 py-1.5 rounded-md text-xs font-medium cursor-pointer transition-all duration-200 ${tipoPrecio === item.id
                                                    ? 'bg-gradient-to-r from-blue-500 to-indigo-500 text-white shadow-md'
                                                    : 'text-gray-600 hover:bg-gray-100'
                                                }`}
                                        >
                                            <input
                                                type="radio"
                                                name="tipoPrecio"
                                                value={item.id}
                                                checked={tipoPrecio === item.id}
                                                onChange={() => setTipoPrecio(item.id)}
                                                className='hidden'
                                            />
                                            {item.precio}
                                        </label>
                                    ))}
                                </div>

                                {/* Repartos link for mobile */}
                                {(roles.includes("41")) && (
                                    <Link
                                        to={'/admin/repartos'}
                                        className={`px-3 py-2 rounded-md text-sm sm:hidden font-medium text-gray-700 hover:bg-blue-100`}
                                    >
                                        Repartos
                                    </Link>
                                )}

                                {/* User menu */}
                                {
                                    mail ? (
                                        <Menu as="div" className="hidden sm:inline-block relative text-left z-10">
                                            <div>
                                                <Menu.Button className="inline-flex items-center gap-2 justify-center px-4 py-2 text-sm font-medium text-gray-700 hover:bg-blue-100 rounded-lg transition-all duration-200">
                                                    <FaUserCircle className='text-lg' />
                                                    <span className='hidden lg:inline'>{mail}</span>
                                                    {
                                                        pendientes && (
                                                            <span className='bg-red-500 text-white font-bold px-2 py-0.5 rounded-full text-xs'>1</span>
                                                        )
                                                    }
                                                </Menu.Button>
                                            </div>
                                            <Transition
                                                as={Fragment}
                                                enter="transition ease-out duration-100"
                                                enterFrom="transform opacity-0 scale-95"
                                                enterTo="transform opacity-100 scale-100"
                                                leave="transition ease-in duration-75"
                                                leaveFrom="transform opacity-100 scale-100"
                                                leaveTo="transform opacity-0 scale-95"
                                            >
                                                <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                    <div className="px-1 py-1 ">
                                                        <Menu.Item>
                                                            {({ active }) => (
                                                                <Link
                                                                    className={`${active ? 'bg-blue-500 text-white' : 'text-gray-900'} group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                                                                    to={"/jornadas"}
                                                                >
                                                                    Jornada de caja
                                                                </Link>

                                                            )}
                                                        </Menu.Item>
                                                        <Menu.Item>
                                                            {({ active }) => (
                                                                <Link
                                                                    className={`${active ? 'bg-blue-500 text-white' : 'text-gray-900'} group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                                                                    to={"/admin"}
                                                                >
                                                                    Administrar Sistema
                                                                </Link>

                                                            )}
                                                        </Menu.Item>
                                                        <Menu.Item>
                                                            {({ active }) => (
                                                                <button
                                                                    className={`${active ? 'bg-blue-500 text-white' : 'text-gray-900'} group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                                                                    onClick={() => cerrarSesion()}
                                                                >
                                                                    Cerrar Sesión
                                                                </button>
                                                            )}
                                                        </Menu.Item>
                                                    </div>
                                                </Menu.Items>
                                            </Transition>
                                        </Menu>
                                    ) : (
                                        <div className='hidden sm:block'>
                                            <button className='border-2 border-blue-500 text-blue-600 px-4 py-2 rounded-lg font-semibold hover:bg-blue-500 hover:text-white transition-all duration-200'
                                                onClick={() => {
                                                    setFormView(3);
                                                    setViewOpen(true);
                                                }}
                                            >
                                                Iniciar Sesión
                                            </button>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>

                    {/* Mobile menu panel */}
                    <Disclosure.Panel className="sm:hidden z-50 absolute w-full bg-white shadow-lg border-t border-gray-200">
                        <div className="px-4 pt-2 pb-3 space-y-1">
                            {navigation.map((item) => (
                                <Disclosure.Button
                                    key={item.name}
                                    as="a"
                                    href={item.href}
                                    className={`block px-4 py-3 rounded-lg text-base font-medium transition-all duration-200 ${item.current ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-blue-100'}`}
                                    aria-current={item.current ? 'page' : undefined}
                                >
                                    {item.name}
                                </Disclosure.Button>
                            ))}

                            {/* Ingreso button in mobile menu */}
                            <button
                                className='w-full text-left px-4 py-3 rounded-lg text-base font-medium text-gray-700 hover:bg-blue-100 transition-all duration-200'
                                onClick={() => {
                                    setFormView(209);
                                    setViewOpen(true);
                                }}
                            >
                                Ingreso
                            </button>
                        </div>

                        {/* Price selector for mobile */}
                        <div className='px-4 pb-3'>
                            <div className='bg-gray-50 rounded-lg p-3 border border-gray-200'>
                                <div className='flex items-center gap-2 mb-2'>
                                    <FaDollarSign className='text-gray-600' />
                                    <p className='text-sm font-semibold text-gray-700'>Tipo de Precio</p>
                                </div>
                                <div className='space-y-2'>
                                    {typeof precios !== 'undefined' && precios.map((item, index) => (
                                        <label
                                            key={index}
                                            className={`flex items-center px-3 py-2 rounded-lg cursor-pointer transition-all duration-200 ${tipoPrecio === item.id
                                                    ? 'bg-gradient-to-r from-blue-500 to-indigo-500 text-white shadow-md'
                                                    : 'bg-white text-gray-700 hover:bg-gray-100'
                                                }`}
                                        >
                                            <input
                                                type="radio"
                                                name="tipoPrecio"
                                                value={item.id}
                                                checked={tipoPrecio === item.id}
                                                onChange={() => setTipoPrecio(item.id)}
                                                className='w-4 h-4 mr-3'
                                            />
                                            <span className='text-sm font-medium'>{item.precio}</span>
                                        </label>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Alertas */}
                        <div className='px-4 pb-3'>
                            <Alertas />
                        </div>

                        {/* User section */}
                        {
                            mail ? (
                                <div className='mx-4 mb-4'>
                                    <div className='bg-gray-50 rounded-lg p-4 border border-gray-200'>
                                        <p className='text-gray-700 text-center mb-3 font-medium flex items-center justify-center gap-2'>
                                            <FaUserCircle className='text-xl' />
                                            {mail}
                                        </p>
                                        <button
                                            className='bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white text-center p-3 rounded-lg w-full font-semibold transition-all duration-200 shadow-md'
                                            onClick={() => cerrarSesion()}
                                        >
                                            Cerrar Sesión
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div className='mx-4 mb-4'>
                                    <Link
                                        className='block text-center bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 rounded-lg transition-all duration-200 shadow-md'
                                        to="/login"
                                    >
                                        Iniciar Sesión
                                    </Link>
                                </div>
                            )
                        }
                    </Disclosure.Panel>
                </>
            )}
        </Disclosure>
    )
}


